import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Simplified for host app - just require authentication, assume all users are hosts
export const RequireRole = ({ children, roles, redirectTo }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-emerald-50/20 via-white to-green-50/10">
        <div className="animate-spin rounded-full h-12 w-12 border-2 border-emerald-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Since this is the host app, all authenticated users are hosts
  // No need to check roles
  return <>{children}</>;
};
